export default __webpack_public_path__ + "static/media/ketogo@3x.25b9c157.png";